import { ModuleBase } from '../../shared/modules';
import { routes } from '../coupons/routes';

export class CouponsModule extends ModuleBase {
  constructor() {
    super({ routes });
  }
}
